module.exports = __webpack_public_path__ + "static/media/farmer-leanne.6dab5f3a.svg";